import axios from "axios";

// Boa prática: usar variáveis de ambiente
const urlBase = process.env.REACT_APP_API_URL || "http://localhost:8080";

const api = axios.create({
  baseURL: urlBase,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 1. Atualizamos para as rotas do QuitaGo
const publicRoutes = ["/public/login", "/public/registrar"];

api.interceptors.request.use((config) => {
  // 2. Usando uma chave única para o QuitaGo no LocalStorage
  const token = localStorage.getItem("@QuitaGo:token"); 
  
  // Normaliza a URL para verificação
  const path = config.url.startsWith('/') ? config.url : `/${config.url}`;
  const isPublic = publicRoutes.some((route) => path.startsWith(route));

  if (token && !isPublic) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    
    // 3. Se o token expirou ou é inválido (401 ou 403)
    if (response && (response.status === 401 || response.status === 403)) {
        // Verifica se o erro NÃO veio de uma tentativa de login/registro
        const isPublic = publicRoutes.some((route) => response.config.url.includes(route));

        if (!isPublic) {
            console.log("Sessão inválida ou expirada.");
            localStorage.removeItem("@QuitaGo:token");
            localStorage.removeItem("@QuitaGo:role");
            
            // Força o reload para limpar o estado do App e cair no Login
            window.location.href = "/login"; 
        }
    }

    return Promise.reject(error);
  }
);

// Remova os dois blocos antigos de interceptors.response e use apenas este:
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // APENAS LOGS, SEM REDIRECIONAMENTO
    if (error.response) {
      console.error("ERRO NO BACKEND:", error.response.status);
      console.error("MENSAGEM:", error.response.data);
    }
    return Promise.reject(error);
  }
);

export default api;